import { render } from "./AcceptContactRequestNotification.vue?vue&type=template&id=d25db34a"
import script from "./AcceptContactRequestNotification.vue?vue&type=script&lang=js"
export * from "./AcceptContactRequestNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__